
export class ProjectSaleAttachmentInfo {
ProjectSaleAttachmentId: number
 ProjectSaleId: number
ProjectSaleAttachmentFileName: string
ProjectSaleAttachmentPathFile: string
CreateDate: string
CreateBy: string
UpdateDate: string
  UpdateBy: string
  progress: number
  SizeFile: number
  traget: number
}
